import AsyncSelect from "react-select/async";
import debounce from "debounce-promise";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useAppStoreState } from "store/AppStore";
import { useBankStatementsStore } from "store/BankStatementsStore";
import { useTheme } from "@emotion/react";
import CreatableSelect from "react-select/creatable";
import { useRemindersStore } from "store/RemindersStore";
import useDebouncedState from "components/useDebouncedState";
import { Input } from "@fluentui/react-components";
const SearchPolicies = () => {
  const { t } = useTranslation();
  const [{ searchPolicyNumbers }, { setRemindersStoreValue }] =
    useRemindersStore();

  const [
    searchPolicyNumbersTerm,
    setSearchPolicyNumbersTerm,
    debouncedSearchPolicyNumbersTerm,
  ] = useDebouncedState(null, 500);

  useEffect(() => {
    // Use debouncedSearchTerm here for API calls or other side effects
    setRemindersStoreValue(
      "searchPolicyNumbers",
      debouncedSearchPolicyNumbersTerm
    );
  }, [debouncedSearchPolicyNumbersTerm]);

  const handleChange = (value) => {
    setSearchPolicyNumbersTerm(value);
  };

  const { appState } = useAppStoreState();

  const customStyles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: appState.darkMode ? "#222222" : "white", // Or any desired color
      color: appState.darkMode ? "white" : "#222222", // Or any desired color
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      minWidth: "300px",
      // minHeight: "30px", // reduce the height
      // height: "30px",
      // padding: "0 6px",

      backgroundColor: appState.darkMode ? "#222222" : "white", // Or any desired color
      color: appState.darkMode ? "white" : "white", // Or any desired color
    }),
    valueContainer: (provided) => ({
      ...provided,
      // height: "30px",
      // padding: "0 6px",
      // alignItems: "center", // vertically center the text
    }),
    input: (baseStyles, state) => ({
      ...baseStyles,
      color: appState.darkMode ? "white" : "#222222",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: appState.darkMode ? "white" : "#222222",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? appState.darkMode
            ? "#000000"
            : "#eeeeee"
          : undefined,
        color: isDisabled
          ? "#ccc"
          : isSelected
          ? appState.darkMode
            ? "white"
            : "#222222"
          : appState.darkMode
          ? "white"
          : "#222222",
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? "yellow"
              : appState.darkMode
              ? "white"
              : "white"
            : undefined,
        },
      };
    },
  };

  return (
    <div data-help="reminders-policy-number">
      <Input
        key={"policyNumber"}
        name={"policyNumber"}
        id={"input_policyNumber"}
        autoComplete="off"
        value={searchPolicyNumbersTerm?.toString() || ""}
        onChange={(e, newValue) => {
          handleChange(newValue.value);
        }}
        placeholder={t("pct.policyNumber.label")}
        onFocus={(e) => {
          e.target.select();
        }}
        onCopy={(e) => e.stopPropagation()}
        onCut={(e) => e.stopPropagation()}
        onPaste={(e) => e.stopPropagation()}
      />
      {/* <CreatableSelect
        isMulti
        id="policiesSearch"
        styles={customStyles}
        menuPlacement={"auto"}
        placeholder={t("pct.searchPolicies.label")}
        noOptionsMessage={() => t("greco.noResults")}
        isClearable
        isDisabled={false}
        loadingMessage={() => t("greco.searching")}
        value={searchPolicyNumbersTerm}
        onChange={(value) => {
          handleChange(value);
        }}
      /> */}
    </div>
  );
};

export default SearchPolicies;
